import { apiNhg } from "../../api/api";
import { IDataUser, IDataUserResponse, ILoginData, ILoginResponse } from "./types";

export class AuthService {
  static async login(loginData: ILoginData): Promise<ILoginResponse> {
    const dataRequest = new URLSearchParams({
      grant_type: loginData.grant_type,
      username: loginData.username,
      password: loginData.password
    }).toString()
    const response = await apiNhg.post<ILoginResponse>('token', dataRequest, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    });
    return response.data;
  }

  static async getDataUser(vidaId: string): Promise<IDataUser> {
    const response = await apiNhg.get<IDataUserResponse>(`/acesso/vida/GetById/${vidaId}`);
    return response.data.Data;
  }
}